import MessageModal from "../../component/MessageModal";

const RegisteredSuccess = () => {
  return <MessageModal message="Student has been registered successfully." />;
};

export default RegisteredSuccess;
